import '@/api/socketConnection';
import '@/lib/prepareConfig';
import '@fontsource/fira-mono/400.css';
import '@fontsource/fira-mono/700.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/700.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
import 'common/misc/dateHelpers';
import 'core-js/proposals/explicit-resource-management';
import 'cross-state/mutative/register';
import 'cross-state/react/register';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'temporal-polyfill/global';
import './index.css';

import authService from '@/api/authService';
import { onSocketMessage } from '@/api/socketConnection';
import router from '@/router';
import { RouterProvider } from '@tanstack/react-router';
import { createRoot } from 'react-dom/client';

// The maintenance flag is part of the session payload - refetch it and re-run the route guards so
// open clients are redirected to/from the maintenance page immediately.
onSocketMessage('maintenance', async () => {
    await authService.appLogin.get({ update: 'force' });
    await router.invalidate();
});

console.groupCollapsed(
    `%c MEREKO ${config.BUILD_BUILDNUMBER} (${config.BUILDTIME.toISOString()})%c`,
    'color: teal; font-weight: bold',
    'color: initial',
);
console.info('Using config', config);
console.groupEnd();

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw Error('Missing root element!');
}

const root = createRoot(rootElement);
root.render(<RouterProvider router={router} />);

Object.assign(window, { Temporal });
